import Polls from './Polls';

export default Polls;
